// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__18z_e","imageUploader":"EGiftCard_imageUploader__EfzNg"};